export default __webpack_public_path__ + "static/media/discovering-signage-system-design.c8779cbf.pdf";